import { TablePage } from 'web-mojo';
import { DeviceHistoryList } from '@portal/models/DeviceHistory.js';

// TODO: Build server-side summary/aggregation endpoint for open_count, avg_open_time, etc.
// For now, this shows the same history data grouped differently.

export default class DeviceSummaryPage extends TablePage {
    constructor(options = {}) {
        super({
            title: 'Summary Report',
            icon: "bi-bar-chart-line-fill",
            pageName: 'summary_report',
            Collection: DeviceHistoryList,

            viewDialogOptions: { header: false },
            requiresGroup: true,
            defaultQuery: {
                sort: '-id',
            },

            columns: [
                { label: "When", key: "created|datetime" },
                { label: "Device", key: "device.name|default(model.device.uuid)" },
                { label: "Action", key: "action" },
                { label: "Source", key: "source" },
                { label: "User", key: "user|default('device')" },
            ],

            emptyMessage: 'No data found.',

            tableOptions: {
                striped: true,
                bordered: false,
                hover: true,
                responsive: false
            },

            showRefresh: true,
            showAdd: false,
            showExport: true,

            tableViewOptions: {
                clickAction: "none",
                hideActivePillNames: ["device__group"]
            },

            ...options,
        });
    }
}
